import { h2Style } from '../layout.js'

/**
 * The heading block every marketing section shares: a small accent label, the
 * h2, and an optional supporting line. Centred by default; the FAQ passes
 * `align="start"` because its heading sits in a column beside the questions.
 */
export function SectionHead({ id, label, title, sub, desktop, align = 'center' }) {
  const centred = align === 'center'

  return (
    <div
      style={{
        textAlign: centred ? 'center' : 'start',
        maxWidth: centred ? 720 : undefined,
        margin: centred ? '0 auto' : undefined,
      }}
    >
      {label && <p className="u-eyebrow">{label}</p>}
      <h2 id={id} style={h2Style(desktop)}>
        {title}
      </h2>
      {sub && (
        <p
          style={{
            fontSize: desktop ? 17 : 15,
            color: 'var(--ink-2)',
            lineHeight: 1.55,
            margin: '12px 0 0',
            maxWidth: 560,
            marginInline: centred ? 'auto' : undefined,
          }}
        >
          {sub}
        </p>
      )}
    </div>
  )
}

export default SectionHead
